<aims-common-table
id="asset-config-sublocations"
[dataSource]="resources | async"
[header]="header"
[pageSize]="10"
[permissions]="tablePermissions| async"
[addRowInitialObject]="addRowInitialObject"
(rowUpdated)="handleRowUpdate($event)"
(rowAdded)="handleRowAdd($event)"
>
<aims-common-table-dynamic-row id="locationId">
 <ng-template viewMode let-element>{{ element.locationId | getText:'locationId':'location':locations| async }}</ng-template>   
 <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
        <aims-lookup
          #aimsControl="ngModel"
          class="fullWidth"
          name="Location"
          [gridText]="'Select a Location'"
          [ngClass]="{'ng-invalid': dynamicControl?.invalid}"
          [values]="locationLookup | async"
          [popupValues]="locationLookup | async"
          displayPropertyName="location"
          idPropertyName="locationId"
          [(ngModel)]="element.locationId"
          [columnsInGrid]="locationLookupColumns"
          [altDisplay]="dynamicControl?.value || 'Select a Parent Location'"
          (valueChangeObj)="handleLookupChange($event, element, dynamicControl)"
        ></aims-lookup>
  </ng-template>
</aims-common-table-dynamic-row>

<aims-common-table-dynamic-row id="siteId">
  <ng-template viewMode let-element>{{ element.siteId | getText:'siteId':'siteName':sites }}</ng-template>
</aims-common-table-dynamic-row>

</aims-common-table>
